import gql from 'graphql-tag'

export const SINCRONIZAR_USUARIOS = gql`
  mutation SincronizarUsuariosMutation {
    sincronizarUsuarios
  }
`
